import type { IInitiateVoiceToTextParams } from './initiateVoiceToText';
import { initiateVoiceToTextParamsSchema } from './initiateVoiceToText';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const INITIATE = 'VOICE_TO_TEXT/INITIATE';

export const initiateActionSchema = objectSchemaOf<IInitiateAction>({
  type: Joi.string().required().valid(INITIATE),
  payload: initiateVoiceToTextParamsSchema.required(),
});

export interface IInitiateAction {
  type: typeof INITIATE;
  payload: IInitiateVoiceToTextParams;
}

export const initiate = actionCreator({
  type: INITIATE,
  schema: initiateActionSchema,
});
